import cx from 'classnames';
import styles from './Hyperlink.module.scss';
export const resolveHyperlinkFont = ({ inherit, size, weight }) => {
    if (inherit) {
        return cx(styles.inherit, { [styles[weight]]: weight === 'bold' });
    }
    return styles[`link${`-${size === 'medium' ? 'regular' : size}`}${weight === 'bold' ? '-bold' : ''}`];
};
